import { ChevronDown, ChevronRight, Search } from '../../../../../icons';
import { SelectOptionProps } from '../../SelectOption.types';
import { DropdownIndicatorProps } from './DropdownIndicator.types';
import { useStyles } from './DropdownIndicator.styles';

export const DropdownIndicator = ({ children, isFocused, ...rest }: DropdownIndicatorProps) => {
  const hasValue = Boolean(rest.getValue()[0]);

  const styles = useStyles();

  const { variant } = rest.selectProps as unknown as SelectOptionProps;
  const getIcon = () => {
    if (variant === 'search' && !hasValue) {
      return (
        <Search
          role="img"
          aria-label="Search"
          size="1.5rem"
          className="cursor-pointer fill-none stroke-primary-400"
        >
          <title>Search</title>
        </Search>
      );
    }

    if (variant !== 'default') return null;

    if (isFocused) {
      return (
        <ChevronDown
          role="img"
          aria-label="Close Menu"
          size="1.5rem"
          className="cursor-pointer stroke-primary-400"
        >
          <title>Close Menu</title>
        </ChevronDown>
      );
    }

    return (
      <ChevronRight
        role="img"
        aria-label="Open Menu"
        size="1.5rem"
        className="cursor-pointer stroke-primary-400"
      >
        <title>Open Menu</title>
      </ChevronRight>
    );
  };

  return (
    <div css={styles.root} data-testid="dropdown_indicator">
      {children}

      {getIcon()}
    </div>
  );
};
